import React, { useState } from "react"

interface DefaultChatProps {
  // handleChoice(channel: string): void
}


export const DefaultChat = ({ }: DefaultChatProps) => {

  const [start, setStart] = useState(false)

  return (
    <div className="w-full">
      <div className="fixed bottom-0 flex max-h-[76%]  w-full flex-grow flex-col rounded-lg bg-[#EEEAE3] ">
        <div className="flex flex-grow  flex-col  overflow-y-auto overflow-x-hidden p-4 border border-primary h-screen rounded-sm">
          <div></div>
        </div>


      </div>
    </div >
  )
}